import { z } from 'zod';
import { DocumentRequirement } from '../client';
import { makeEvent } from './EventBase';

export const DocumentRequirementUpdated = makeEvent(
    'DocumentRequirementUpdated',
    z.object({
        data: DocumentRequirement,
    }),
);

export type DocumentRequirementUpdated = (typeof DocumentRequirementUpdated)['schema']['_output'];
